import requests from "./httpService";

const HotChartServices = {

    getHotChart: async () => {
        return requests.get(`/content/hot-charts`);
    },
    createHotChart: async (body) => {
        return requests.post(`/content/hot-charts`, body);
    },
    updateHotChart: async (id, body) => {
        return requests.put(`/content/hot-charts/${id}`, body);
    },
    deleteHotChart: async (id) => {
        return requests.delete(`/content/hot-charts/${id}`);
    },
}

export default HotChartServices;
